import { useContext, useState } from "react";
import React from 'react';

export function createUpdatableContext() {
	return React.createContext({
		value: null,
		updateFunction: null // placeholder
	});
}

export function useInitialUpdatableContext(startVal = null) {
	let [ctx, updateCtx] = useState(null);
	let ctxReady = (ctx != null);
	if(ctx == null || ctx.updateFunction == null) {
		let myUpdateFunction = (newval) => {
			updateCtx({
				value: newval,
				updateFunction: myUpdateFunction
			})
		};
		myUpdateFunction(startVal);
	};
	return [ctx?.value, ctx?.updateFunction, ctx, ctxReady];
}

export function useUpdatableContext(ctxType) {
	let ctx = useContext(ctxType);
	return [ctx.value, ctx.updateFunction];
}